/**
 * @module FieldControls
 */
import { FormControl, FormGroup, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a Choice field. Available values will be populated from the FieldSettings.
 */
export const DropDownList = props => {
  var _props$localization, _props$settings$Optio2;
  const localization = deepMerge(defaultLocalization.dropdownList, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.dropdownList);
  const getInitialstate = () => {
    if (!props.fieldValue) {
      if (props.actionName === 'new') {
        var _props$settings$Optio;
        if (props.settings.DefaultValue) {
          const defaultValue = changeTemplatedValue(props.settings.DefaultValue).split(/,|;/);
          return props.settings.AllowMultiple ? defaultValue : defaultValue.slice(0, 1);
        }
        if ((_props$settings$Optio = props.settings.Options) !== null && _props$settings$Optio !== void 0 && _props$settings$Optio.length) {
          var _props$fieldOnChange;
          const selectedOnCtd = props.settings.Options.reduce((selection, option) => {
            if (option.Selected) {
              selection.push(option.Value);
            }
            return selection;
          }, []);
          const fieldValue = props.settings.AllowMultiple ? selectedOnCtd : selectedOnCtd.slice(0, 1);
          (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, fieldValue);
          return fieldValue;
        }
      }
      return [''];
    }
    if (!Array.isArray(props.fieldValue)) {
      return [props.fieldValue];
    }
    return props.fieldValue;
  };
  const [value, setValue] = useState(getInitialstate);
  const handleChange = event => {
    var _props$fieldOnChange2;
    setValue(event.target.value);
    (_props$fieldOnChange2 = props.fieldOnChange) === null || _props$fieldOnChange2 === void 0 ? void 0 : _props$fieldOnChange2.call(props, props.settings.Name, Array.isArray(event.target.value) ? event.target.value : [event.target.value]);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(FormControl, {
        style: {
          minWidth: '220px',
          width: '100%'
        },
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly
      }, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: props.settings.Name,
        shrink: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Select, {
        onChange: handleChange,
        inputProps: {
          name: props.settings.Name,
          id: props.settings.Name
        },
        value: value,
        name: props.settings.Name,
        multiple: props.settings.AllowMultiple,
        autoWidth: true,
        fullWidth: true
      }, (_props$settings$Optio2 = props.settings.Options) === null || _props$settings$Optio2 === void 0 ? void 0 : _props$settings$Optio2.map(option => {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: option.Value,
          value: option.Value,
          selected: option.Selected
        }, option.Text);
      })), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      {
        var _props$settings$Optio6, _props$settings$Optio7, _props$settings$Optio8;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          gutterBottom: true
        }, props.settings.DisplayName), /*#__PURE__*/React.createElement(FormGroup, null, props.fieldValue ? Array.isArray(props.fieldValue) ? props.fieldValue.length ? props.fieldValue.map((val, index) => {
          var _props$settings$Optio3, _props$settings$Optio4, _props$settings$Optio5;
          return /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            gutterBottom: index === props.fieldValue.length - 1,
            key: index
          }, (_props$settings$Optio3 = (_props$settings$Optio4 = props.settings.Options) === null || _props$settings$Optio4 === void 0 ? void 0 : (_props$settings$Optio5 = _props$settings$Optio4.find(item => item.Value === val)) === null || _props$settings$Optio5 === void 0 ? void 0 : _props$settings$Optio5.Text) !== null && _props$settings$Optio3 !== void 0 ? _props$settings$Optio3 : '');
        }) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          gutterBottom: true
        }, localization.noValue) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          gutterBottom: true
        }, (_props$settings$Optio6 = (_props$settings$Optio7 = props.settings.Options) === null || _props$settings$Optio7 === void 0 ? void 0 : (_props$settings$Optio8 = _props$settings$Optio7.find(item => item.Value === props.fieldValue)) === null || _props$settings$Optio8 === void 0 ? void 0 : _props$settings$Optio8.Text) !== null && _props$settings$Optio6 !== void 0 ? _props$settings$Optio6 : '') : /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          gutterBottom: true
        }, localization.noValue)));
      }
  }
};
//# sourceMappingURL=dropdown-list.js.map